<template>
  <header class="app-header navbar">

    <div class="modal fade show " id="modalRelatoriosVenda" tabindex="-1" role="dialog"
      aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
      data-backdrop="static" v-if="showModalInteracoes">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Lançar Interação</h4>
          </div>
          <div class="modal-body">
            
            <div class="row">
              <div class="col-md-3 form-group">
                <label>Data Lançamento:</label><br>
                <input-data-hora-picker class="data-hora form-control" v-model="interacao.dataLancamento" />
              </div>
              <div class="form-group col-sm-9 col-md-9">
                <label>Tipo de Interação:</label>
                <select class="pula form-control custom" v-validate="'required'" v-model="interacao.motivoInteracaoId">
                  <option v-for="motivoInteracao in motivosInteracoes" v-bind:value="motivoInteracao.id">{{motivoInteracao.nome}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12">
                <label>Titular:</label>
                <input v-model="interacao.titularId" type="hidden" name="titularInteracoesId" />
                <input v-model="interacao.titularTipo" type="hidden" name="titularInteracoesTipo" />
                <buscar-titular v-model="interacao.titular" v-validate="'required'" id="titularInteracoes" placeholder="Nome do Titular" :classes="{ input: 'pula form-control', wrapper: 'input-wrapper'}" :on-select="setarTitularInteracoes" :on-blur="verificarTitularInteracoes" />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12">
                <label>Descrição:</label><br>
                <textarea rows="4" class="pula form-control" v-validate="'required'" v-model="interacao.descricao" />
              </div>
            </div>

  
          </div>
          <div class="modal-footer">
            <button id="imprimirVendaModal" type="button" class="btn btn-success" v-on:click="gravarInteracao">
              <i v-if="isLoading" class="fa fa-spinner fa-spin"></i> Gravar
            </button>
            <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalInteracoes = false">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" v-on:click="esconderMenu">
      <span class="navbar-toggler-icon"></span>
    </button>
    <button class="sidebar-minimizer d-md-down-none navbar-toggler" type="button" v-on:click="esconderMenu">
      <span class="navbar-toggler-icon"></span>
    </button>

    <a class="navbar-brand" href="#"><img height="40" v-bind:src="'/static/images/logo.png'"> </img></a>
    
    <div class="navbar-dados-empresa">
      <span><strong>{{model.nomeFantasia}}</strong></span><br>
      <template v-if="model.nomeFantasia !== model.nome">
        <span>{{model.nome}} &nbsp;&nbsp; </span>
      </template> 
      <span>{{model.documento}}</span>
    </div>

    <ul class="nav navbar-nav ml-auto">
      <li class="nav-item dropdown">
        <a class="nav-link nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
          <img src="/static/images/avatar.png" class="img-avatar" alt="Menu de Usuário">
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <div class="dropdown-header text-center">
            <strong>Configuração</strong>
          </div>
          
          <a class="dropdown-item" href="javascript:void(Tawk_API.toggle())"><i class="fa fa-question-circle-o"></i> Suporte</a>
          <a class="dropdown-item" href="#"><i class="fa fa-user"></i> Perfil</a>
          <a class="dropdown-item" href="#"><i class="fa fa-wrench"></i> Configurações</a>
          <div class="divider"></div>
          <a v-on:click="logout()" class="dropdown-item" href="#"><i class="fa fa-lock"></i> Sair </a>
        </div>
      </li>
      

    </ul>
  </header>
</template>

<script>
import axios from 'axios'
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase. (by vue-strap)
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen (target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false)
      return {
        remove () {
          target.removeEventListener(eventType, callback, false)
        }
      }
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback)
      return {
        remove () {
          target.detachEvent('on' + eventType, callback)
        }
      }
    }
  }
}
export default {
  data () {
    return {
      model: {
        id: '1',
        nomeFantasia: '',
        nome: '',
        tipoEmpresa: 'J',
        documento: '',
        inscricaoEstadual: '',
        inscricaoMunicipal: '',
        inscricaoSuframa: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidadeId: '',
        cidadeNome: '',
        cep: '',
        estado: '',
        contato: '',
        telefone: '',
        email: '',
        regimeTributario: '1',
        cnae: '',
        tipoAtividade: '',
        regimeEspecialServicos: '',
        incentivadorCultural: '',
        grauRisco: '',
        codigoGPS: '',
        codigoFRAPS: ''
      },
      interacao: {
        dataLancamento: this.dataHoraAtual(),
        titularId: '0',
        titularTipo: '',
        titularNome: '',
        titular: '',
        descricao: '',
        motivoInteracaoId: '0',
        motivoInteracaoNome: ''
      },
      motivosInteracoes: [],
      showModalInteracoes: false,
      isLoading: false
    }
  },
  created: function () {
    // this.buscarEmpresa()
  },
  methods: {
    buscarEmpresa: function () {
      var self = this
      var config = {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      var url = '/api/empresas/1'
      axios.get(url, config)
      .then(function (response) {
        self.model.id = response.data.id
        self.model.nomeFantasia = response.data.nomeFantasia
        self.model.nome = response.data.nome
        self.model.tipoEmpresa = response.data.tipoEmpresa
        self.model.documento = response.data.documento
        self.model.inscricaoEstadual = response.data.inscricaoEstadual
        self.model.inscricaoMunicipal = response.data.inscricaoMunicipal
        self.model.inscricaoSuframa = response.data.inscricaoSuframa
        self.model.endereco = response.data.endereco
        self.model.numero = response.data.numero
        self.model.complemento = response.data.complemento
        self.model.bairro = response.data.bairro
        self.model.cidadeId = response.data.cidadeId
        self.model.cidadeNome = response.data.cidadeNome
        self.model.cep = response.data.cep
        self.model.estado = response.data.estado
        self.model.contato = response.data.contato
        self.model.telefone = response.data.telefone
        self.model.email = response.data.email
      })
    },
    interacoesModal: function () {
      this.showModalInteracoes = true
      this.buscarMotivosInteracoes()
      this.interacao.dataLancamento = this.dataHoraAtual()
      this.interacao.titularId = '0'
      this.interacao.titularTipo = ''
      this.interacao.titularNome = ''
      this.interacao.titular = ''
      this.interacao.descricao = ''
      this.interacao.motivoInteracaoId = '0'
      this.interacao.motivoInteracaoNome = ''
      this.isLoading = false
    },
    buscarMotivosInteracoes: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarMotivoInteracoesAtivos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.motivosInteracoes = response.data
        for (let i = 0; i < self.motivosInteracoes.length; i++) {
          if (i === 0) {
            self.interacao.motivoInteracaoId = self.motivosInteracoes[i].id
          }
        }
      })
    },
    setarTitularInteracoes: function (titular) {
      this.interacao.titularId = titular.id
      this.interacao.titularTipo = titular.tipoCadastro[0]
      this.interacao.titular = titular.nomeFantasia
      $(this.$el).find('#titularInteracoes').val(titular.nomeFantasia)
    },
    verificarTitularInteracoes: function () {
      if ($(this.$el).find('#titularInteracoesId').val() === '0') {
        this.interacao.titularId = 0
        this.interacao.titular = ''
        this.interacao.titularTipo = ''
        $(this.$el).find('#titularInteracoesId').val(0)
        $(this.$el).find('#titularInteracoes').val('')
      }
      if ($(this.$el).find('#titularInteracoes').val() === '') {
        this.interacao.titularId = 0
        this.interacao.titular = ''
        this.interacao.titularTipo = ''
        $(this.$el).find('#titularInteracoesId').val(0)
        $(this.$el).find('#titularInteracoes').val('')
      }
      console.log($(this.$el).find('#titularInteracoes').val())
    },
    gravarInteracao: function (titular) {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(JSON.stringify(self.interacao))
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          self.isLoading = true
          var url = '/api/titularesInteracoes/salvar'
          axios.post(url, JSON.stringify(self.interacao), config)
          .then(function (response) {
            console.log(response)
            if (response.data === 'OK') {
              self.$toastr('success', 'Interação gravada com sucesso.', 'Atenção')
              self.showModalInteracoes = false
              self.isLoading = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        } else {
          this.$toastr('error', 'Complete os campos destacados.', 'Atenção')
        }
      })
    },
    esconderMenu: function () {
      this.$store.state.sistema.collapsed = !this.$store.state.sistema.collapsed
    },
    logout: function () {
      this.$auth.logout()
      this.$router.replace('/login')
    }
  },
  ready () {
    const dropdowns = document.querySelectorAll('.dropdown > .dropdown-toggle')
    if (dropdowns) {
      for (var i = 0; i < dropdowns.length; i++) {
        dropdowns[i].addEventListener('click', (e) => {
          e.preventDefault()
          e.target.offsetParent.classList.add('open')
        })
      }
    }
    this._closeEvent = EventListener.listen(window, 'click', (e) => {
      if (e.target.classList.contains('dropdown-toggle')) {
        return
      }
      const dropdowns = document.querySelectorAll('.dropdown')
      for (let i = 0; i < dropdowns.length; i++) {
        dropdowns[i].classList.remove('open')
      }
    })
  },
  carregarJivoChat () {
    var widgetId = 'nAkknTQd03'
    var d = document
    var w = window
    function l () {
      var s = document.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.src = '//code.jivosite.com/script/widget/' + widgetId
      var ss = document.getElementsByTagName('script')[0]
      ss.parentNode.insertBefore(s, ss)
    }
    if (d.readyState === 'complete') {
      l()
    } else {
      if (w.attachEvent) {
        w.attachEvent('onload', l)
      } else {
        w.addEventListener('load', l, false)
      }
    }
  },
  beforeDestroy () {
    if (this._closeEvent) {
      this._closeEvent.remove()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/navbar.vue